export default {
  name: "alert",
  data() {
    return {
      alert: {
        success: false,
        message: ""
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/alert.js
// module id = HC+g
// module chunks = 18